import { useEffect, useState } from "react";

function remaining(target) {
  const diff = new Date(target).getTime() - Date.now();
  return Math.max(0, diff);
}

export default function Countdown({ to, className = "", testId, onExpire }) {
  const [ms, setMs] = useState(() => remaining(to));

  useEffect(() => {
    setMs(remaining(to));
    const t = setInterval(() => {
      const r = remaining(to);
      setMs(r);
      if (r <= 0) { clearInterval(t); onExpire?.(); }
    }, 1000);
    return () => clearInterval(t);
  }, [to, onExpire]);

  if (ms <= 0) return null;
  const total = Math.floor(ms / 1000);
  const d = Math.floor(total / 86400);
  const h = Math.floor((total % 86400) / 3600);
  const m = Math.floor((total % 3600) / 60);
  const s = total % 60;
  const pad = (n) => String(n).padStart(2, "0");
  const label = d > 0 ? `${d}d ${pad(h)}:${pad(m)}:${pad(s)}` : `${pad(h)}:${pad(m)}:${pad(s)}`;

  return (
    <span data-testid={testId} className={`tabular-nums ${className}`}>{label}</span>
  );
}
